// Modul zur Erfassung von einfachen Kosten
"use strict";

import module from "./module.js";

export default module;
